import Logo from './Components/Logo';
import NavItems from './Components/NavItems';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PageHome from './PageHome'
import PageAfspraken from './PageAfspraken';
import PagePraktisch from './PagePraktisch';
import PageTeam from './PageTeam';
import PageVisie from './PageVisie';
import PageNieuwePatiënten from './PageNieuwePatienten';
import PageContact from './PageContact';
import PageLinks from './PageLinks';

function App() {
  return (
    <>
      <Router>
        <div className="body-overlay"></div>

        { /* 'hidden' menu shown by the hamburger icon: */}
        <div className='dosislite-menu-touch'>
          <Logo className="logo-navbar" />
          <NavItems className="main-menu-vertical" />
        </div>

        { /* 'default' main page: */}
        <div className='main-wrapper-boxed'>
          <Navbar />
          <div id='content' className='dosislite-primary'>
            <div className='main-container'>
              <div className='container'>
                <div className='page-content'>
                  <div className='row justify-content-md-center'>
                    <div className='col-md-11 col-lg-10'>
                      <Routes>
                        <Route path='/' exact element={<PageHome />} />
                        <Route path='/afspraken/' exact element={<PageAfspraken />} />
                        <Route path='/praktisch/' exact element={<PagePraktisch />} />
                        <Route path='/team/' exact element={<PageTeam />} />
                        <Route path='/visie/' exact element={<PageVisie />} />
                        <Route path='/nieuwepatienten/' exact element={<PageNieuwePatiënten />} />
                        <Route path='/contact/' exact element={<PageContact />} />
                        <Route path='/links/' exact element={<PageLinks />} />
                      </Routes>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
